var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{attrs:{"id":"home"}},[_c('banner',{staticStyle:{"margin-bottom":"2rem"}}),_c('router-view',{staticClass:"mx-auto text-left",staticStyle:{"margin-bottom":"2rem"},attrs:{"align":"justify"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }